module.exports = __webpack_public_path__ + "static/media/bacc.5e1ef025.jpg";